export const Spacer = () => {
    return <div style={styles.spacer}></div>
}

const styles = {
    spacer: {
        height: '25px',
    },
}
